import React from 'react';
import PropTypes from 'prop-types';
import Picture from 'components/elements/Picture';

const AboutWrapper = (props) => {
    if(props.about_wrapper===false) return <>{props.children}</>

    return (<div data-test-id="about-wr" className={"widget widget-aboutblock" + (props?.dark ? " bg-dark" : "")}>
        {props.children}
    </div>)
}
function SimpleTextListWidget(props) {
    if (!props?.title && !props?.text && !props?.text2 && !props?.img && !props?.img_mob) return null;

    return (
        <AboutWrapper {...props}>
            <div className="container-xl row text-center mx-auto p-0">
                {
                    props?.img?.source || props?.img_mob?.source ?
                        <Picture dti="about-img" img={props.img} img_mob={props.img_mob} className='text-null col-12 col-md-6 mb-3 mb-md-0' />
                        :
                        null
                }
                {props?.title ? <h3 data-test-id="about-title" className={(props?.dark ? "text-white " : "") + "text-left text-sm-center d-flex align-items-center col-12 col-md-6"}>{props.title}</h3> : null}
                {
                    props?.text || props?.text2 ?
                    <div className="row mt-4 mt-md-5 mx-0 w-100">
                        {
                            props?.text ?
                                <div className="col-12 col-md-6 mb-sm-12">
                                    <p data-test-id="about-left-text" className={(props?.dark ? 'text-white ' : '') + 'text-medium text-sm-small text-justify text-sm-center'}>{props.text}</p>
                                </div>
                                : null
                        }                        
                        {
                            props?.text2 ?
                                <div className="col-12 col-md-6">
                                    <p data-test-id="about-right-text" className={(props?.dark ? 'text-white ' : '') + 'text-medium text-sm-small text-justify text-sm-center'}>{props.text2}</p>
                                </div>
                                : null
                        }
                    </div>
                    : null
                }
            </div>
        </AboutWrapper>
    )
}

SimpleTextListWidget.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    widget: PropTypes.string
}

export default SimpleTextListWidget;
